import Base from "./Base";
import _ from "underscore";
import {pathname} from "../others/Configuration";

export default Base.extend({

        initialize: function () {

            this.url = _.compact([pathname, "/dashboard/api/v1/articleshistory"]).join("");
        },

        buildURL: function (options) {
     
            switch (options.action) { 
                case "remove":
                    return _.compact([this.url, "/delete"]).join(""); 
            }
        },

        setFromAPI: function (response, options) {
           
            switch (options.action) { 
                case "remove":
                    this.set({
                        "state": "removed",
                        "html": response
                    });
                    break; 
            }
        },

        setErrorFromAPI: function (response, options) {

            this.set("error", true);
            this.trigger("error");
        } 
    });
